import React, { useState } from 'react';
import { User, Save } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import toast from 'react-hot-toast';
import './ProfilePage.css';

export default function ProfilePage() {
  const { user, updateUser } = useAuth();
  const [form, setForm] = useState({
    name: user?.name || '',
    phone: user?.phone || '',
    street: user?.address?.street || '',
    city: user?.address?.city || '',
    postalCode: user?.address?.postalCode || '',
    country: user?.address?.country || 'CH',
  });
  const [loading, setLoading] = useState(false);
  const [pw, setPw] = useState({ currentPassword: '', newPassword: '', confirm: '' });
  const [pwLoading, setPwLoading] = useState(false);

  const handleProfileSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.put('/auth/update-profile', {
        name: form.name,
        phone: form.phone,
        address: { street: form.street, city: form.city, postalCode: form.postalCode, country: form.country }
      });
      updateUser(res.data.user);
      toast.success('Profile updated!');
    } catch (err) {
      toast.error('Update failed');
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    if (pw.newPassword !== pw.confirm) return toast.error('Passwords do not match');
    setPwLoading(true);
    try {
      await api.put('/auth/change-password', { currentPassword: pw.currentPassword, newPassword: pw.newPassword });
      toast.success('Password changed!');
      setPw({ currentPassword: '', newPassword: '', confirm: '' });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Password change failed');
    } finally {
      setPwLoading(false);
    }
  };

  return (
    <div className="profile-page container">
      <div className="profile-header">
        <div className="avatar"><User size={32} /></div>
        <div>
          <h1>{user?.name}</h1>
          <p>{user?.email}</p>
          {user?.role === 'admin' && <span className="badge">Admin</span>}
        </div>
      </div>

      <div className="profile-grid">
        <div className="profile-section">
          <h2>Personal Information</h2>
          <form onSubmit={handleProfileSave}>
            <div className="form-group"><label>Full Name</label>
              <input className="form-control" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
            </div>
            <div className="form-group"><label>Phone</label>
              <input className="form-control" type="tel" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
            </div>
            <h3 style={{ marginTop: 20, marginBottom: 12 }}>Shipping Address</h3>
            <div className="form-group"><label>Street</label>
              <input className="form-control" value={form.street} onChange={e => setForm({ ...form, street: e.target.value })} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div className="form-group"><label>Postal Code</label>
                <input className="form-control" value={form.postalCode} onChange={e => setForm({ ...form, postalCode: e.target.value })} />
              </div>
              <div className="form-group"><label>City</label>
                <input className="form-control" value={form.city} onChange={e => setForm({ ...form, city: e.target.value })} />
              </div>
            </div>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Saving...' : <><Save size={16} /> Save Changes</>}
            </button>
          </form>
        </div>

        <div className="profile-section">
          <h2>Change Password</h2>
          <form onSubmit={handlePasswordChange}>
            <div className="form-group"><label>Current Password</label>
              <input className="form-control" type="password" value={pw.currentPassword} onChange={e => setPw({ ...pw, currentPassword: e.target.value })} required />
            </div>
            <div className="form-group"><label>New Password</label>
              <input className="form-control" type="password" value={pw.newPassword} onChange={e => setPw({ ...pw, newPassword: e.target.value })} required />
            </div>
            <div className="form-group"><label>Confirm New Password</label>
              <input className="form-control" type="password" value={pw.confirm} onChange={e => setPw({ ...pw, confirm: e.target.value })} required />
            </div>
            <button type="submit" className="btn-secondary" disabled={pwLoading}>
              {pwLoading ? 'Updating...' : 'Update Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
